module.exports = __webpack_public_path__ + "static/v18-dd51eb598f0bbbd0186f47b70e37f85a.jpg";